import { render, staticRenderFns } from "./IncomeAddItemModal.vue?vue&type=template&id=68db3828&"
import script from "./IncomeAddItemModal.vue?vue&type=script&lang=ts&"
export * from "./IncomeAddItemModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports